import * as yup from 'yup'

const importKbFormValidationSchema = yup
  .object({
    type: yup.string().oneOf(['happyfox_helpdesk', 'zendesk_support', 'csv_file']),
    url: yup
      .string()
      .trim()
      .when('type', {
        is: (value) => value !== 'csv_file',
        then: (schema) => schema.required('URL is required').url('Please enter a valid URL')
      }),
    name: yup.string().trim().required('Name is required').min(3, 'Name should contain at least ${min} characters'),
    file: yup.mixed().when('type', {
      is: 'csv_file',
      then: (schema) =>
        schema.required('File is required').test('fileFormat', 'Please upload a csv file', (value) => {
          return value?.[0]?.type.includes('text/csv') ?? false
        })
    })
  })
  .required()

export default importKbFormValidationSchema
